import { render } from "./EthIcon.vue?vue&type=template&id=2be4a91c&scoped=true"
const script = {}

import "./EthIcon.vue?vue&type=style&index=0&id=2be4a91c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be4a91c"]])

export default __exports__